module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_yoso_location@3x-165c82a7162ec12f1e1954c6cf6e020f.webp";